import { Price } from "~/common/Store/models/ProductListing";

export default (price: Price, activeSale: boolean) => {
  if (!price.minimumAdvertisedPriceProperties) {
    return false;
  }

  const hasValidMapStyleLetter =
    !!price.minimumAdvertisedPriceProperties.type.trim() &&
    price.minimumAdvertisedPriceProperties.type.trim() !== "R";

  const p4IsLowestPrice =
    price.minimumAdvertisedPriceProperties.price <
    Math.min(activeSale ? price.salePrice : Infinity, price.price);

  return hasValidMapStyleLetter && p4IsLowestPrice;
};
